import {CampaignService} from "@/services/campaign";
import { errorMessage } from '@/constants/common';

export const CampaignMixin = {
  data() {
    return {
      campaign: {},
      campaignId: this.$route.params.campaign_id,
    }
  },
  methods: {
    async fetchCampaign() {
      const { data, res } = await CampaignService.fetchCampaign(
        this.campaignId || this.$route.params.campaign_id
      );
      if (res.status !== 200) {
        alert(data.detail || errorMessage);
        return this.$router.replace("/");
      }
      this.campaign = data;
      this.saveCampaignToState()
    },
    saveCampaignToState() {
      this.$store.commit("set", ["currentCampaignName", this.campaign.name])
      this.$store.commit("set", ["campaign", this.campaign]);
    }
  }
};
